import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import {
  GetGanttModalDetails,
  WeeklyGanttDataResponse,
} from 'src/app/models/gantt/gantt.model';
import {
  GanttRequest,
  GetGanttResponse,
} from 'src/app/shared/gantt/interfaces/Gant.interface';
import {
  BooleanResponse,
  GetSideBarGanttDataRequest,
  GetSideBarGanttDataResponse,
  UpdateSidebarRequest,
} from 'src/app/shared/gantt/interfaces/gantt-details.model';
import { environment } from 'src/environments/environment';

export type DelayCausedBy = 'CLIENT' | 'CAFLER' | 'UNDEFINED';

export interface MarkServiceLateRequest {
  orderHash: string;
  nodeId: string;
  causedBy: DelayCausedBy;
  reasonCode: string;
}

export interface MarkServiceLateResponse {
  isSuccess: boolean;
  message?: string;
}

@Injectable({
  providedIn: 'root',
})
export class GanttService {
  url: string = environment.url;

  private readonly delayPath = `${this.url}/gantt/sidebar/mark-late`;
  constructor(private http: HttpClient) {}

  public getGantt(request: GanttRequest): Observable<GetGanttResponse> {
    return this.http.post<GetGanttResponse>(`${this.url}/gantt`, request);
  }

  getWeeklyGanttData(
    zoneGuids: string[],
    startDateSeconds?: number,
    bufferAmount?: number
  ): Observable<WeeklyGanttDataResponse> {
    const body = {
      zoneGuids,
      startDate: startDateSeconds
        ? { seconds: startDateSeconds, nanos: 0 }
        : undefined,
      buffer_amount: bufferAmount,
    };

    return this.http.post<WeeklyGanttDataResponse>(
      `${this.url}/freelance-pool-gantt/GetWeeklyGanttData`,
      body
    );
  }

  getGanttModalData(nodeId: string): Observable<GetGanttModalDetails> {
    const params = new HttpParams().set('nodeId', nodeId);
    return this.http.get<GetGanttModalDetails>(
      `${this.url}/freelance-pool-gantt/GetGanttModalData`,
      { params }
    );
  }

  getSidebarData(
    nodeId: string,
    isService: boolean,
    originNodeId?: string
  ): Observable<GetSideBarGanttDataResponse> {
    const payload: GetSideBarGanttDataRequest = { nodeId, isService };
    if (originNodeId) payload.originNodeId = originNodeId;

    return this.http.post<GetSideBarGanttDataResponse>(
      `${this.url}/gantt/sidebar`,
      payload
    );
  }

  updateSidebar(request: UpdateSidebarRequest): Observable<BooleanResponse> {
    return this.http.post<BooleanResponse>(
      `${this.url}/gantt/sidebar/update`,
      request
    );
  }

  markServiceAsLate(
    request: MarkServiceLateRequest
  ): Observable<MarkServiceLateResponse> {
    return this.http.post<MarkServiceLateResponse>(this.delayPath, request);
  }
}
